export { default, getServerSideProps } from "pages/[lang]/astrology";
